export default {
  data() {
    return {
      isSmView: false,
      isMdView: false,
      isLgView: false,
      isDesktopView: false,
      isInboxMobileView: false,
    };
  },
  created() {
    this.checkView();
    window.addEventListener("resize", this.checkView);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkView);
  },
  methods: {
    checkView() {
      if (matchMedia) {
        let mediaQuery = window.matchMedia("(max-width: 575px)");
        this.isSmView = mediaQuery.matches;
        mediaQuery = window.matchMedia("(max-width: 767px)");
        this.isMdView = mediaQuery.matches;
        mediaQuery = window.matchMedia("(max-width: 1000px)");
        this.isLgView = mediaQuery.matches;
        mediaQuery = window.matchMedia("(min-width: 1200px)");
        this.isDesktopView = mediaQuery.matches;
      }
    },
  },
};
